import React, { useEffect, useRef, useState } from "react";
import Dashboard from "../../components/Dashboard"; // For Admin & Employer
import EmpDashboard from "../EmployeeDashboard/EmployeeDashboard";
import { getUserInfoFromToken } from "../../utils/authUtils";

const MainDashboard = () => {
  // const userType = localStorage.getItem("user_type");

  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  const formikRef = useRef();
          useEffect(() => {
          const { userType, userId } = getUserInfoFromToken();
          setUserType(userType);
          setUserId(userId);
        }, []);
  
  if (userType === "Admin" || userType === "Employer") {
    return <Dashboard/>;
  }

  if (userType === "Employee") {
    return <EmpDashboard />;
  }

  return <div>User type not recognized</div>; // Fallback
};

export default MainDashboard;
